import React from 'react';
import { Applications } from './Applications';
import { Certification } from './Certification';
import { Competiteurs } from './Competiteurs';
import { Produits } from './Produits';
import { UserReviewGallery } from './UserReviews';

export const SeoStuff = () => {

    return <div>
        <div className="dark"><UserReviewGallery /></div>
        <div className='orange'>
            <Competiteurs />
        </div>
        <div >
            <Applications />
        </div>
        <div className='dark'>
            <Produits />
        </div>
        <div className='orange'>
            <Certification />
        </div>
    </div>;

};
